import React from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import HomeIcon from "@mui/icons-material/Home";
import RefreshIcon from "@mui/icons-material/Refresh";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary] Caught error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  handleGoHome = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "80vh",
            p: 3,
          }}
        >
          <Paper
            elevation={0}
            sx={{
              p: 5,
              maxWidth: 500,
              textAlign: "center",
              borderRadius: 3,
              border: "1px solid #fecaca",
              backgroundColor: "#fef2f2",
            }}
          >
            <ErrorOutlineIcon
              sx={{ fontSize: 64, color: "#ef4444", mb: 2 }}
            />
            <Typography variant="h5" fontWeight={700} sx={{ mb: 1 }}>
              Er ging iets mis
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ mb: 3 }}
            >
              Er is een onverwachte fout opgetreden. Probeer de pagina opnieuw
              te laden of ga terug naar de homepagina.
            </Typography>
            {this.state.error && (
              <Typography
                variant="caption"
                sx={{
                  display: "block",
                  mb: 3,
                  p: 1.5,
                  borderRadius: 1,
                  backgroundColor: "rgba(239,68,68,0.08)",
                  color: "#b91c1c",
                  fontFamily: "monospace",
                  wordBreak: "break-word",
                }}
              >
                {this.state.error.toString()}
              </Typography>
            )}
            <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
              <Button
                variant="contained"
                startIcon={<RefreshIcon />}
                onClick={this.handleReset}
                sx={{
                  backgroundColor: "#6366f1",
                  "&:hover": { backgroundColor: "#4f46e5" },
                  borderRadius: 2,
                  textTransform: "none",
                }}
              >
                Probeer opnieuw
              </Button>
              <Button
                variant="outlined"
                startIcon={<HomeIcon />}
                onClick={this.handleGoHome}
                sx={{
                  borderColor: "#d1d5db",
                  color: "#374151",
                  "&:hover": { borderColor: "#9ca3af", backgroundColor: "#f9fafb" },
                  borderRadius: 2,
                  textTransform: "none",
                }}
              >
                Naar Home
              </Button>
            </Box>
          </Paper>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
